import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Procedure } from '@project/view-models';
import { ApiService } from '@core/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ProceduresService {
  private readonly _proceduresSubject = new BehaviorSubject<Procedure[]>([]);
  public readonly procedures$ = this._proceduresSubject.asObservable();

  constructor(private readonly apiService: ApiService) {}

  // createApacForm(apacForm: ApacForm): Observable<void> {
  //   const url = `${environment.environmentVariables.apiCoreUrl}/SigtapProcedure`;
  //   return this.apiService.post<void>(url, apacForm).pipe(catchError(this.handleError<void>('createApacForm')));
  // }

  getSADTProcedures(searchQuery: string): Observable<Procedure[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/SigtapProcedure?procedureType=SADT&Search=${searchQuery}`;
    return this.apiService.get<Procedure[]>(url).pipe(
      tap((procedures) => this._proceduresSubject.next(procedures)),
      catchError(this.handleError<Procedure[]>('getSADTProcedures', [])),
    );
  }

  getAPACProcedures(searchQuery: string): Observable<Procedure[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/SigtapProcedure?procedureType=APAC&Search=${searchQuery}`;
    return this.apiService.get<Procedure[]>(url).pipe(
      tap((procedures) => this._proceduresSubject.next(procedures)),
      catchError(this.handleError<Procedure[]>('getAPACProcedures', [])),
    );
  }

  getProcedureById(id: string): Observable<Procedure> {
    const url = `${environment.environmentVariables.apiCoreUrl}/${id}`;
    return this.apiService.get<Procedure>(url).pipe(
      tap((procedure) => console.log('getProcedureById response:', procedure)),
      catchError(this.handleError<Procedure>('getProcedureById')),
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }
}
